import { ColorSenseBar } from './color-sense-bar/ColorSenseBar';
import { GoodsDetail } from './detail/GoodsDetail';
import { Divider } from './Divider';
import { ToneMap } from './tone-map/ToneMap';

import type { PersonalColorMap, ProductView } from '@lemoncloud/epyt-goods-api';

interface GoodsProps {
    data: ProductView;
}

export const Goods = ({ data }: GoodsProps) => {
    const mapData = (data.map$ ?? (data as ProductView & { map?: PersonalColorMap }).map) as
        | PersonalColorMap
        | undefined;

    return (
        <main className="px-4 pb-6">
            <GoodsDetail data={data} />
            <Divider />

            {mapData && (
                <>
                    <section aria-labelledby="tone-map-heading">
                        <h2 id="tone-map-heading" className="sr-only">
                            톤 맵
                        </h2>
                        <ToneMap map$={mapData} />
                    </section>
                    <Divider />
                </>
            )}

            <section aria-labelledby="color-sense-bar-heading">
                <h2 id="color-sense-bar-heading" className="sr-only">
                    컬러 센스 바
                </h2>
                <ColorSenseBar analysis$={data.analysis$} />
            </section>
            <Divider />
        </main>
    );
};
